<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{ getLanguageOEMI(this.getUserInfo.OEMI,"AHRPT",'SAHRPT')}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-if="bool_showSearchBar && this.getUserInfo.AT !== 4">
                        <div class='searchBox'>
                            <!--<div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['AG']['GN']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_agentgroup"
                                            :defaultExpandLevel="Infinity"
                                            :flat="true"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            class="searchdashboard"
                                            v-model="searchAgent"
                                            @input="nextGetUpdate(true, true, true)" />
                            </div>-->
                            <!--<div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['AG']['PG']}}</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadSubAgentOptions"
                                            :options="dd_subagentList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent" />
                            </div>-->
                            <!--<div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AG"]["GN"]}} :</span>
                                <CInput size="sm" :value="arr_FV['GN']" @change="v => arr_FV['GN'] = v"></CInput>
                            </div>-->
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["AG"]["PG"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroup"
                                            :defaultExpandLevel="Infinity"
                                            :clearable="false"
                                            :disable-branch-nodes="true"
                                            :flat="true"
                                            :placeholder="this.utilGetDDLanguage('AG.PG')"
                                            v-model="parentGroupId" />
                            </div>
                        </div>
                        <div class=' searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="getSubReportList()" ref="search" class='searchBtn' size="sm" block color="success" @click="getSubReportList()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage['BTN']['SR']}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header d-flex">
                    <div class="d-flex align-items-center">
                        <strong>{{ getLanguageOEMI(this.getUserInfo.OEMI,"AHRPT",'SAHRPT')}}</strong>
                        <div class="ml-2">
                            <span>
                                <span style=" border-right: solid 1px; padding-right: 5px;">(<i class="fas fa-user theme-agent mr-1"></i> <strong>{{ getLanguageOEMI(this.getUserInfo.OEMI,"AG","A") }}</strong></span>
                                <!-- <span style=" border-right: solid 1px; padding-right: 5px;"><i class="fas fa-users theme-subagent mr-1"></i> <strong>{{getLanguage["BETRPT"]["SAG"]}}</strong></span> -->
                                <span style=" border-right: solid 1px; padding-right: 5px;"><i class="fas fa-users theme-subagent mr-1"></i> <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"SUB","AG")}}</strong></span>
                                <span v-if="getUserInfo.OEMI != 2" style=" border-right: solid 1px; padding-right: 5px;"><i class="fa-solid fa-house theme-outlet mr-1"></i> <strong>{{getLanguage["SUB"]["OLT"]}}</strong></span>
                                <span><span class="subagent-icon mr-1" style="background: #0c1033 !important; padding-top: 0; ">0</span> <strong>{{getLanguage["AFF"]["T"]}}</strong>)</span>
                            </span>
                        </div>
                    </div>

                </header>

                <div class="custom-table-wrapper" :class="this.getUserInfo.OEMI==2?'subagent-oem-hierarchy':'subagent-hierarchy'">
                    <v-treeview v-model="treeData"
                                :treeTypes="this.getUserInfo.OEMI==2?treeTypesOEM2:treeTypes"
                                :openAll="openAll" :openNode="openNode" @contextmenu.prevent>
                        <template v-slot:prepand="{item}">
                            <span v-if="item.isnew" class="badge badge-danger">{{getLanguage["GAME"]["NEW"]}}</span>
                            <span v-if="item.isggearn"> <img src="https://media.afb.gg/BackOfficeSiteIco/ggearn-ico2.png" class="nwithdraw-icon" /></span>
                            <span v-if="item.type!='DN'"  style="z-index: 2;position:relative" @click="openWinLossSubAgent(item)"><i class="fas fa-arrow-circle-right text-danger"></i></span>
                        </template>
                    </v-treeview>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    //import VTreeview from "v-treeview";
    import VTreeview from "@/views/CustomTreeView/CustomTreeview";
    import genericHelper from "@/modules/GenericHelper.js";
    import { mapGetters, mapActions } from 'vuex';
    import { loadingFullScreen } from '@/modules/Constant.js';
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'

    export default {
        mixins: [genericHelper],
        components: {
            VTreeview,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_showDetails: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                openAll: true,
                treeTypes: [
                    {
                        type: "#",
                        max_children: 99999,
                        max_depth: 20,
                        valid_children: [
                            "A"
                        ]
                    },
                    {
                        type: "A",
                        icon: "fas fa-user theme-agent",
                        valid_children: ["SAG"]
                    },
                    {
                        type: "1",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag1",
                        valid_children: ["DN"]
                    },
                    {
                        type: "2",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag2",
                        valid_children: ["DN"]
                    },
                    {
                        type: "3",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag3",
                        valid_children: ["DN"]
                    },
                    {
                        type: "4",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag4",
                        valid_children: ["DN"]
                    },
                    {
                        type: "5",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag5",
                        valid_children: ["DN"]
                    },
                    {
                        type: "6",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag6",
                        valid_children: ["DN"]
                    },
                    {
                        type: "7",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag7",
                        valid_children: ["DN"]
                    },
                    {
                        type: "8",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag8",
                        valid_children: ["DN"]
                    },
                    {
                        type: "9",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag9",
                        valid_children: ["DN"]
                    },
                    {
                        type: "10",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag10",
                        valid_children: ["DN"]
                    },
                    {
                        type: "11",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag11",
                        valid_children: ["DN"]
                    },
                    {
                        type: "12",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag12",
                        valid_children: ["DN"]
                    },
                    {
                        type: "13",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag13",
                        valid_children: ["DN"]
                    },
                    {
                        type: "14",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag14",
                        valid_children: ["DN"]
                    },
                    {
                        type: "15",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag15",
                        valid_children: ["DN"]
                    },
                    {
                        type: "16",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag16",
                        valid_children: ["DN"]
                    },
                    {
                        type: "17",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag17",
                        valid_children: ["DN"]
                    },
                    {
                        type: "18",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag18",
                        valid_children: ["DN"]
                    },
                    {
                        type: "19",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag19",
                        valid_children: ["DN"]
                    },
                    {
                        type: "20",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag20",
                        valid_children: ["DN"]
                    },
                    {
                        type: "1O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet1",
                        valid_children: ["DN"]
                    },
                    {
                        type: "2O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet2",
                        valid_children: ["DN"]
                    },
                    {
                        type: "3O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet3",
                        valid_children: ["DN"]
                    },
                    {
                        type: "4O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet4",
                        valid_children: ["DN"]
                    },
                    {
                        type: "5O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet5",
                        valid_children: ["DN"]
                    },
                    {
                        type: "6O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet6",
                        valid_children: ["DN"]
                    },
                    {
                        type: "7O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet7",
                        valid_children: ["DN"]
                    },
                    {
                        type: "8O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet8",
                        valid_children: ["DN"]
                    },
                    {
                        type: "9O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet9",
                        valid_children: ["DN"]
                    },
                    {
                        type: "10O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet10",
                        valid_children: ["DN"]
                    },
                    {
                        type: "11O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet11",
                        valid_children: ["DN"]
                    },
                    {
                        type: "12O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet12",
                        valid_children: ["DN"]
                    },
                    {
                        type: "13O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet13",
                        valid_children: ["DN"]
                    },
                    {
                        type: "14O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet14",
                        valid_children: ["DN"]
                    },
                    {
                        type: "15O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet15",
                        valid_children: ["DN"]
                    },
                    {
                        type: "16O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet16",
                        valid_children: ["DN"]
                    },
                    {
                        type: "17O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet17",
                        valid_children: ["DN"]
                    },
                    {
                        type: "18O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet18",
                        valid_children: ["DN"]
                    },
                    {
                        type: "19O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet19",
                        valid_children: ["DN"]
                    },
                    {
                        type: "20O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet20",
                        valid_children: ["DN"]
                    },
                    {
                        type: "DN",
                        icon: "fas fa-link",
                        valid_children: []
                    },
                ],
                treeTypesOEM2: [
                    {
                        type: "#",
                        max_children: 99999,
                        max_depth: 20,
                        valid_children: [
                            "A"
                        ]
                    },
                    {
                        type: "A",
                        icon: "fas fa-user theme-agent",
                        valid_children: ["SAG"]
                    },
                    {
                        type: "1",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag1-oem2",
                        valid_children: ["DN"]
                    },
                    {
                        type: "2",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag2-oem2",
                        valid_children: ["DN"]
                    },
                    {
                        type: "3",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag3",
                        valid_children: ["DN"]
                    },
                    {
                        type: "4",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag4",
                        valid_children: ["DN"]
                    },
                    {
                        type: "5",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag5",
                        valid_children: ["DN"]
                    },
                    {
                        type: "6",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag6",
                        valid_children: ["DN"]
                    },
                    {
                        type: "7",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag7",
                        valid_children: ["DN"]
                    },
                    {
                        type: "8",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag8",
                        valid_children: ["DN"]
                    },
                    {
                        type: "9",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag9",
                        valid_children: ["DN"]
                    },
                    {
                        type: "10",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag10",
                        valid_children: ["DN"]
                    },
                    {
                        type: "11",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag11",
                        valid_children: ["DN"]
                    },
                    {
                        type: "12",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag12",
                        valid_children: ["DN"]
                    },
                    {
                        type: "13",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag13",
                        valid_children: ["DN"]
                    },
                    {
                        type: "14",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag14",
                        valid_children: ["DN"]
                    },
                    {
                        type: "15",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag15",
                        valid_children: ["DN"]
                    },
                    {
                        type: "16",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag16",
                        valid_children: ["DN"]
                    },
                    {
                        type: "17",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag17",
                        valid_children: ["DN"]
                    },
                    {
                        type: "18",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag18",
                        valid_children: ["DN"]
                    },
                    {
                        type: "19",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag19",
                        valid_children: ["DN"]
                    },
                    {
                        type: "20",
                        icon: "fas fa-users theme-subagent gg-ico gg-ico-sag20",
                        valid_children: ["DN"]
                    },
                    {
                        type: "1O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet1",
                        valid_children: ["DN"]
                    },
                    {
                        type: "2O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet2",
                        valid_children: ["DN"]
                    },
                    {
                        type: "3O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet3",
                        valid_children: ["DN"]
                    },
                    {
                        type: "4O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet4",
                        valid_children: ["DN"]
                    },
                    {
                        type: "5O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet5",
                        valid_children: ["DN"]
                    },
                    {
                        type: "6O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet6",
                        valid_children: ["DN"]
                    },
                    {
                        type: "7O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet7",
                        valid_children: ["DN"]
                    },
                    {
                        type: "8O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet8",
                        valid_children: ["DN"]
                    },
                    {
                        type: "9O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet9",
                        valid_children: ["DN"]
                    },
                    {
                        type: "10O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet10",
                        valid_children: ["DN"]
                    },
                    {
                        type: "11O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet11",
                        valid_children: ["DN"]
                    },
                    {
                        type: "12O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet12",
                        valid_children: ["DN"]
                    },
                    {
                        type: "13O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet13",
                        valid_children: ["DN"]
                    },
                    {
                        type: "14O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet14",
                        valid_children: ["DN"]
                    },
                    {
                        type: "15O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet15",
                        valid_children: ["DN"]
                    },
                    {
                        type: "16O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet16",
                        valid_children: ["DN"]
                    },
                    {
                        type: "17O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet17",
                        valid_children: ["DN"]
                    },
                    {
                        type: "18O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet18",
                        valid_children: ["DN"]
                    },
                    {
                        type: "19O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet19",
                        valid_children: ["DN"]
                    },
                    {
                        type: "20O",
                        icon: "fa-solid fa-house theme-outlet gg-ico gg-ico-outlet20",
                        valid_children: ["DN"]
                    },
                    {
                        type: "DN",
                        icon: "fas fa-link",
                        valid_children: []
                    },
                ],
                treeData: [],
                contextItems: [],
                selectedNode: null,
                dd_agentgroup: [],
                parentGroupId: null,
                openNode: null,
            }
        },
        methods: {
            getSubReportList() {
                this.bool_fullLoading = true;
                var that = this;

                if (this.getUserInfo.AT === 4) {
                    this.parentGroupId = '0-0'
                }

                if (this.parentGroupId != null) {
                    var tempAgi = that.parentGroupId.split("-");
                    var agi = tempAgi[1];

                    this.getDataApi(`/api/dd/sag-h/${agi}/1`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d && d.D) {
                                    that.treeData = d.D;

                                    if (that.getUserInfo.AT < 2) {
                                        that.openAll = false;
                                        that.openNode = d.D[0].id;
                                    } else {
                                        that.openAll = true;
                                        that.openNode = null;
                                    }
                                }
                                else {
                                    that.treeData = [];
                                }
                            }
                            else {
                                that.treeData = [];
                            }
                        });
                } else {
                    this.bool_fullLoading = false;
                }
            },
            getAgentGroupDropdown() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }

                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                } else {
                    item.isDisabled = false;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            openWinLossSubAgent(item) {
                if (this.parentGroupId != null) {
                    var agi = this.parentGroupId;
                    var subagi = item.type == 'A' ? 0 : item.id;
                    let routeData = this.$router.resolve({ path: '/R/SAGTWL', query: { agi: agi, subagi: subagi } });
                    window.open(routeData.href, '_blank');
                }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo']),
            ...mapGetters('UserInfo', ['checkModuleAccess']),
        },
        watch: {
        },
        created() {
            this.$parent.showSubMenu = 'AGS';
            this.$parent.showActiveMenu = 'AGS.SUBHRY';

            var parameters = this.$route.query;
            //$router.push("/AGS/SUBHRY?agi=" + agi);
            //eg agi = "3-10"

            if (parameters.agi !== undefined) {
                this.parentGroupId = parameters.agi;
            }

            this.getAgentGroupDropdown();
            this.getSubReportList();
        },
    }
</script>






// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/SubAgentHierarchy.vue